import React from 'react';
import { Link, Navigate, useOutletContext, useParams } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import { hasProduct } from './clientProducts';

// WEST-989: the nav hides products a county doesn't have, but their pages still loaded from a
// typed or bookmarked URL. Wrap a product's routes in this so they show a "not available"
// message instead. The Tax library also refuses to start a payment for these counties.
const PRODUCT_LABELS = {
  tpay: 'Online tax payments',
  tax: 'Online tax search',
  doc: 'Document search',
};

const RequireProduct = ({ product, children }) => {
  const { dataClient } = useOutletContext() ?? {};
  const { customerId } = useParams();

  if (!dataClient) {
    return <LoadingSpinner />;
  }

  if (!hasProduct(dataClient, product)) {
    const label = PRODUCT_LABELS[product] ?? 'This service';
    return (
      <div className="product-not-available">
        <p>
          {label} {label.endsWith('s') ? "aren't" : "isn't"} available for {dataClient.name || 'this county'}.
        </p>
        {product !== 'tax' && hasProduct(dataClient, 'tax') && (
          <p>
            <Link to={`/customer/${customerId}/taxSearch`}>Search property taxes</Link>
          </p>
        )}
      </div>
    );
  }

  return children;
};

// WEST-989: /customer/:id used to always redirect to paymentsSearch, which a county without
// Web Pay can't use. Send it to the first product the county has.
export const CustomerLanding = () => {
  const { dataClient } = useOutletContext() ?? {};

  if (!dataClient) {
    return <LoadingSpinner />;
  }

  if (!hasProduct(dataClient, 'tpay') && hasProduct(dataClient, 'tax')) {
    return <Navigate to="taxSearch" replace />;
  }

  return <Navigate to="paymentsSearch" replace />;
};

export default RequireProduct;
